import {Button} from '@/components/ui/button/Button'
import {DetailsFieldsSection} from '@/components/ui/details-atoms/DetailsAtoms'
import {shadows} from '@/theme/shadows'
import styled, {css} from 'styled-components'

export const StyledDetailsFieldsSection = styled(DetailsFieldsSection)(
    ({theme: {spacing}}) => css`
        display: grid;
        grid-template-rows: auto 1fr;
        min-height: 234px;
        & .section-body {
            padding-bottom: ${spacing * 3}px;
        }
    `
)

export const StyledTeamButton = styled(Button)<{$isActive: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        opacity: ${$isActive ? 1 : 0.7};
        ${$isActive &&
        css`
            outline: 1px solid ${palette.primary['300']};
            background-color: ${palette.neutral['white']};
            box-shadow: ${`${shadows.sm}, 0px 0px 0px 4px ${palette.primary['100']}`};
        `};
    `
)
